import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import React from 'react';
import { getStockColor, StockChartProps } from '.';
import { optionsDaily } from './config';

const StockChartDaily: React.FC<StockChartProps> = ({
  stockData,
  showTimeInToolTip = false,
}) => {
  const stockColor = getStockColor(stockData);
  const stockOptions = optionsDaily(
    [...stockData],
    stockColor,
    showTimeInToolTip
  );
  return (
    <div className="h-full w-full">
      <HighchartsReact highcharts={Highcharts} options={{ ...stockOptions }} />
    </div>
  );
};

export { StockChartDaily };
